import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('Margin', {
    root: (props) => ({
        margin: props.margin,
    }),
});
export const Margin = (props) => (isolateComponent("div", { css: Styles.root(props) }, props.children));
//# sourceMappingURL=Margin.js.map
// @zapier/design-system@6.30.3 (c0cf05278)
